export function readComplaintPhotos(value) {
  if (value == null || value === '') return { urls: [], damaged: false };
  if (Array.isArray(value)) {
    const results = value.map(readComplaintPhotos);
    return { urls: [...new Set(results.flatMap(result => result.urls))], damaged: results.some(result => result.damaged) };
  }
  if (typeof value !== 'string') return { urls: [], damaged: true };
  const text = value.trim();
  if (!text) return { urls: [], damaged: false };
  if (/^[\[{"]/.test(text)) {
    try { return readComplaintPhotos(JSON.parse(text)); }
    catch { return { urls: [], damaged: true }; }
  }
  if (/^(data:image\/|https?:\/\/|blob:|\/uploads\/|uploads\/)/i.test(text)) return { urls: [text], damaged: false };
  return { urls: [], damaged: true };
}
